/* eslint-disable react/no-array-index-key */
import React from 'react';
import { MdContentCopy } from 'react-icons/md';
import { FaQrcode } from 'react-icons/fa';
import styles from './QRCode.module.css';

function useQRCode(commands) {
  const openCopyModal = () => commands.copy.openModal();

  const openCodeModal = () => commands.code.openModal();

  return ({
    eventHandlers: {
      openCopyModal,
      openCodeModal,
    },
    localStates: {

    },
  });
}

export default function QRCode(props) {
  const { commands, sharedStates } = props;
  const { localStates, eventHandlers } = useQRCode(commands);

  if (sharedStates.paymentMethod !== 'bank_transfer' || !sharedStates.spacePix) return null;

  return (
    <section className={styles.container}>
      <p className={styles.explanation}>Você pode usar PIX copia-e-cola ou código QR, tanto por aqui, quanto pelo e-mail que você recebeu.</p>
      <div className={styles.buttonsBox}>
        <button className={styles.btn} onClick={eventHandlers.openCopyModal}>
          <MdContentCopy size={24} color="#fff" />
          <p className={styles.title}>Copiar</p>
        </button>
        <button className={styles.btn} onClick={eventHandlers.openCodeModal}>
          <FaQrcode size={24} color="#fff" />
          <p className={styles.title}>Código QR</p>
        </button>
      </div>
    </section>
  );
}
